export interface CognitoResponeErrorModel {
    message: string,
    code: string
}